import React, { useState } from 'react';
import StyledText from './StyledText';
import { useTheme } from '../../middleware/ThemeContext';
import { Subtitle } from '../DeletePrompt';
import styled from 'styled-components';

interface ColorPicker {
    title?: string;
    subTitle?: React.ReactNode;
    color: string;
    setColor: (color: string) => void;
    className?: string;
    isResponsive?: boolean
}

const StyledColorPicker: React.FC<ColorPicker> = ({ title, subTitle, color, setColor, className, isResponsive }) => {
    const { theme } = useTheme();

    return (
        <ColorPickerContainer isResponsive={isResponsive} className={className} style={{ backgroundColor: theme.CorporateTheme.colors.filterBG, border: `0.5px solid ${theme.CorporateTheme.colors.border}` }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '10px' }}>
                <div
                    style={{
                        width: isResponsive ? 30 : 40,
                        height: isResponsive ? 30 : 40,
                        borderRadius: '50%',
                        backgroundColor: color,
                    }}
                />
                <StyledText
                    htmlTag={'span'}
                    textColor={theme.CorporateTheme.colors.headerColor}
                    fontFamily='Lato'
                    fontStyle='italic'
                    fontSize='12px'
                    fontWeight={500}
                >
                    {color}
                </StyledText>
            </div>

            {title && subTitle &&
                <div className='mt-3'>
                    <StyledText
                        fontSize={isResponsive ? '14px' : '16px'}
                        fontWeight={600}
                        textColor={theme.CorporateTheme.colors.headerColor}
                    >
                        {title}
                    </StyledText>
                    <StyledText
                        textColor={theme.CorporateTheme.colors.textSecondary}
                        fontSize={isResponsive ? '10px' : '12px'}
                        fontWeight={500}
                        className='mt-1'
                    >
                        {subTitle}
                    </StyledText>
                </div>
            }
            <input
                type="color"
                value={color}
                onChange={(e) => setColor(e.target.value)}
                style={{
                    width: 40,
                    height: 40,
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    // display: 'none',
                }}
            />
        </ColorPickerContainer>
    );
};

export default StyledColorPicker;

const ColorPickerContainer = styled.label<{ isResponsive?: boolean }>`
    position: relative;
    border-radius: 5px;
    width: ${({ isResponsive }) => isResponsive ? '200px' : '224px'};
    // height: 124px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 16px 20px;
    input {
        position: absolute;
        opacity: 0;
        bottom: 0;
        right: 0;
    }
`;